import React from 'react'
import PropTypes from 'prop-types'

import Options from './Options'

import Columns from 'react-bulma-components/lib/components/columns'
import Column from 'react-bulma-components/lib/components/columns/components/column'
import Heading from 'react-bulma-components/lib/components/heading'

import './Scenario.sass'

function Scenario ({ title, slider, first, second }) {
  return <div className='scenario'>
    <Heading size={5}>{title}</Heading>
    <hr />
    <Columns className='scenario'>
      <Column size='half'>
        <Options {...first} slider={slider} />
      </Column>
      <Column size='half'>
        <Options {...second} slider={slider} />
      </Column>
    </Columns>
  </div>
}

Scenario.propTypes = {
  first: PropTypes.any,
  second: PropTypes.any,
  title: PropTypes.string
}

export default Scenario
